<div
  class="drawing-area-2d"
  #drawingArea2D
  [class.draw-mode]="isDrawingMode"
  [class.select-mode]="isSelectMode"
  (mousedown)="onMouseDown($event)"
  (touchstart)="onTouchStart($event)"
>
  <img [src]="modelUrl" alt="2D View" class="image-viewer" (load)="modelLoaded.emit()" (error)="modelLoaded.emit()" />

  <div
    *ngFor="let rect of rectangles; let i = index"
    class="drawn-rectangle"
    [style.left.px]="rect.left"
    [style.top.px]="rect.top"
    [style.width.px]="rect.width"
    [style.height.px]="rect.height"
    [title]="
      rect.note
        ? ('modelViewer.noteWithContent' | translate: { note: rect.note })
        : ('modelViewer.addNoteTooltip' | translate)
    "
    (mousedown)="onRectangleClick($event, i)"
    (touchstart)="onRectangleTouchStart($event, i)"
  >
    <span *ngIf="rect.note" class="rect-note-icon">
      <i class="fas fa-comment-dots"></i>
    </span>
  </div>

  <div
    *ngIf="currentRect"
    class="drawn-rectangle drawing"
    [style.left.px]="currentRect.left"
    [style.top.px]="currentRect.top"
    [style.width.px]="currentRect.width"
    [style.height.px]="currentRect.height"
  ></div>

  <div
    *ngIf="pendingRect"
    class="drawn-rectangle pending"
    [style.left.px]="pendingRect.left"
    [style.top.px]="pendingRect.top"
    [style.width.px]="pendingRect.width"
    [style.height.px]="pendingRect.height"
  ></div>
</div>
